import React from 'react';
import './StorySectionTwo.css';

export default function StorySectionTwo() {
  return (
    <section className="section story-two-section" id="story-3">
      <div className="story-two-split">
        <div className="story-two-media" aria-hidden="true" />
        <div className="story-two-pane">
          <div className="container">
            <div className="story-two-content">
              <h3 className="story-two-kicker">The Best Part</h3>
              <div className="story-two-est">THE CHERRY ON TOP</div>
              <p className="story-two-text">
                We dish out these frozen treats completely FREE until our freezer runs dry. All we ask is that your
                organization manage the event so every guest gets their fair share of the cool fun.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
